import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ImageFile} from '../../../../../models/image-file';

@Component({
  selector: 'preview-file',
  templateUrl: './preview-file.component.html',
  styleUrls: ['./preview-file.component.scss']
})
export class PreviewFileComponent {

  @Input()
  public file: ImageFile;
  @Output()
  public downloadFile: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  public removeFileEvent: EventEmitter<any> = new EventEmitter<any>();

  public showDeleteBtn = false;

  onDownloadFile(evt) {
    this.downloadFile.emit(evt);
  }

  onDeleteFile(evt) {
    this.removeFileEvent.emit(evt);
  }

  onMouseEnter(evt) {
    this.showDeleteBtn = true;
  }

  onMouseLeave(evt) {
    this.showDeleteBtn = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/main/campaigns-add/upload-file/preview-file/preview-file.component.ts